import React from "react";

const SupplieCodeOfConduct = () => {
  return (
    <div className="container">
      <br />
      <h1 className="service">CTL Australia Supplie Code of Conduct:</h1>
      <br />
      <a
        href="/pdfpreview?v1706160202/CTLDocuments/CTL_Australia_Supplier_Code_of_Conduct.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary btn-block mb-4 CTL_btn p-1 ps-2 pe-2"
      >
        CTL Supplier Code of Conduct <i class="bi bi-file-earmark-pdf-fill"></i>
      </a>

    </div>
  );
};

export default SupplieCodeOfConduct;
